import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { DataFetcherHookResult } from '@ts-core/core/types';

import { Course } from '../types';
import { getCoursesQuery, GetCoursesQueryResult } from '../graphql/queries/getCoursesQuery';

type CoursesHookResult = DataFetcherHookResult<Course[], 'courses'>;

export default function useCourses(): CoursesHookResult {
  const { data, loading, error } = useQuery<GetCoursesQueryResult>(getCoursesQuery);

  return { loading, error: getErrorMessage({ error }), courses: data?.courses };
}
